import { useEffect, useRef } from 'react'
import Swiper from 'swiper'
import { SwiperOptions } from 'swiper/types'

export type SwiperHook = ReturnType<typeof useSwiper>

export const useSwiper = (selector: string, options: SwiperOptions) => {
	const swiperRef = useRef<Swiper | null>(null)

	useEffect(() => {
		if (swiperRef.current && typeof swiperRef.current.destroy === 'function') {
			swiperRef.current.destroy()
			swiperRef.current = null
		}

		try {
			swiperRef.current = new Swiper(selector, options)
		} catch (error) {
			console.error('Failed to create Swiper instance:', error)
		}

		return () => {
			if (swiperRef.current && typeof swiperRef.current.destroy === 'function') {
				swiperRef.current.destroy()
				swiperRef.current = null
			}
		}
	}, [selector, JSON.stringify(options)])

	return swiperRef
}
